var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.0101C31.0424 12.6855 29.9821 13.2022 28.86 13.5401C28.2577 12.8476 27.4573 12.3567 26.567 12.134C25.6767 11.9112 24.7395 11.9673 23.8821 12.2945C23.0247 12.6218 22.2884 13.2045 21.773 13.9638C21.2575 14.7231 20.9877 15.6224 21 16.5401V17.5401C19.2426 17.5856 17.5013 17.1959 15.931 16.4055C14.3607 15.6151 13.0103 14.4487 12 13.0101C12 13.0101 8 22.0101 17 26.0101C14.9405 27.408 12.4872 28.109 10 28.0101C19 33.0101 30 28.0101 30 16.5101C29.9991 16.2315 29.9723 15.9537 29.92 15.6801C30.9406 14.6735 31.6608 13.4028 32 12.0101Z",
    fill: "#006CB8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.b1b492edee0a9dd3b0016a0c41e1740f.svg";
export { ForwardRef as ReactComponent };